<header class="header">
  <div class="header__navigation">
    <a
      class="header__logo-link"
      routerLink="/"
    >
      <img
        class="header__logo"
        src="assets/logo.svg"
        alt="Logo"
      />
    </a>
    <ul class="header__list list">
      <li>
        <a
          class="list__item"
          color="primary"
          routerLink="components"
          routerLinkActive="list__item_active"
        >
          Components
        </a>
      </li>
      <li>
        <a
          class="list__item"
          color="primary"
          routerLink="features"
          routerLinkActive="list__item_active"
        >
          Features
        </a>
      </li>
    </ul>
  </div>
  <div class="header__actions actions">
    <div class="actions__change-framework">
      <a class="actions__link actions__link_angular">
        <img
          class="header__navigation-logo"
          src="assets/angular-logo.svg"
          alt="Angular Logo"
        />
      </a>
      <a
        class="actions__link"
        href="/react/"
      >
        <img
          class="header__navigation-logo"
          src="assets/react-logo.svg"
          alt="React Logo"
        />
      </a>
    </div>
    <a
      class="actions__link"
      href="https://github.com/saritasa-nest/saritasa-frontend-solutions"
      target="_blank"
    >
      <img
        class="header__navigation-logo"
        src="assets/github-logo.svg"
        alt="GitHub Logo"
      />
    </a>
  </div>
</header>
